<template>
  <v-app-bar app tile clipped-left color="primary" dark height="64">
    <v-row no-gutters align="center">
      <v-col cols="3" justify="start">
        <h1 class="text-uppercase">Λthena</h1>
      </v-col>
      <v-col cols="9">
        <v-row no-gutters align="center" justify="end" class="flex-nowrap">
          <im-hotel-selector/>
          <v-divider vertical class="mx-3"/>
          <im-profile-button/>
        </v-row>
      </v-col>
    </v-row>
  </v-app-bar>
</template>

<script>
  export default {
    components: {
      'im-hotel-selector': () => import('@/components/TheHotelSelector'),
      'im-profile-button': () => import('@/components/TheProfileButton')
    }
  }
</script>